import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from'firebase'
const crypto = require('crypto');
const messengerCr = require('./u2uMessaging.js')
const cipher = require('./cipher.js')
const bcrypt = require('bcryptjs');
const fetch = require('node-fetch');
const encrFile = require('./encrFile.js')
import router from '../router'
// import { firebaseAuth} from 'firebase'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fetchFeed:[],
    fetchFriends:[],
    fetchGroupMessages: {},
    fetchDms:[],
    fetchMessages: {},
    user:null,
    loading: false,
    error: null,
    allUsers:{},
    postInteraction:[],
    postComments:{},
    friends: {},
    pKey:{},
    currentPost:{},
    groupChat: {},
    groupMembers:{},
    pass: null,
    arrayOfUsers:[],
    notifications: {}
  },
  getters:{
    fetchFeeds (state){
      return state.fetchFeed.sort((feedA, feedB) => {
        return feedA.date > feedB.date;
      })
    },
    friends(state) {
      return state.friends
    },
    arrayUser(state) {
      return state.arrayOfUsers.filter(user=>{
        return user.id !== state.user.id
      })
    },
    fetchFriends (state) {
      return state.fetchFriends
    },
    fetchFriend (state) {
      return (friendId) => {
        return state.fetchFriends.find((friend) => {
          return friend.id === friendId
        })
      }
    },
    search(state, name) {
      for(let user in state.allUsers) {
        if( state.allUsers[user].username === name) {
          return state.allUsers[user]
        }
      }
    },
    fetchFeed(state) {
      return friendId =>{
        return state.fetchFeed.find(feed => {
          return feed.id === friendId
        })
      }
    },
    featuredFeed(state, getters) {
      return getters.fetchFeeds.slice(0, 5);
    },
    user(state) {
      return state.user
    },
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    allUsers (state){
      let usersFiltered ={}
      Object.keys(state.allUsers).forEach(key => {
        if(key !== state.user.id) {
          usersFiltered[key]= state.allUsers[key]
        }
      })
      return usersFiltered

    },
    fetchMessages(state) {
      return state.fetchMessages
    },
    fetchGroupMessages(state) {
      return state.fetchGroupMessages
    },
    groupchat(state){
      return state.groupChat
    }
  },
  mutations: {
    createPost (state, payload) {
      state.fetchFeed.push(payload)
    },
    setPrivatePost (state, payload) {
      if(payload !== []){
        state.fetchFeed.push(payload)
      }
    },
    setFeeds (state, payload) {
      if(payload !== []){
        state.fetchFeed.push(payload)
      }
    },
    setUser (state, payload){
      state.user = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload){
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    addUser(state, payload){
      Vue.set(state.allUsers, payload.userId, payload.userDetails)
    },
    arrayUser(state, payload){
      state.arrayOfUsers= payload
    },
    addMessage(state, payload) {
      Vue.set(state.fetchMessages, payload.messageId, payload.messageDetails)
    },
    addGroupMessage(state, payload) {
      Vue.set(state.fetchGroupMessages, payload.messageId, payload.messageDetails)
    },
    addDms(state, payload) {
      state.fetchFriends= payload
    },
    addDMGroups(state, payload) {
      state.fetchDms = payload
    },
    clearMessages (state) {
      state.fetchMessages= {}
    },
    clearGroupMessages (state) {
      state.fetchGroupMessages= {}
    },
    addPostInteractions(state, payload) {
      Vue.set(state.postInteraction, payload.postId, payload.postDetails)
    },
    likePosts(state, payload) {
      state.postInteraction.push(payload)
    },
    addComments(state, payload) {
      Vue.set(state.postComments, payload.commentId, payload.commentDetails)
    },
    clearComments(state) {
      state.postComments= {}
    },
    addFriends(state, payload) {
      Vue.set(state.friends, payload.friendId, payload.friendDetails)
    },
    setKey(state, payload){
      state.pKey = payload
      //Vue.set(state.pKey, payload.publicKey, payload.privKey)
    },
    disableKey(state){
      state.pKey= null
    },
    thisPost(state, payload){
      state.currentPost = payload
    },
    signout(state) {
      state.fetchFeed=[]
      state.fetchFriends={}
      state.fetchMessages= {}
      //state.allUsers={}
      state.postInteraction=[]
      state.postComments={}
      state.friends = {},
      state.pKey={},
      state.currentPost={},
      state.groupChat= {},
      state.groupMembers={},
      state.notifications= {},
      state.pass= null,
      //state.arrayOfUsers=[],
      state.notifications= {},
      state.user= null
    },
    addGroupChat(state, payload){
      Vue.set(state.groupChat, payload.chatId, payload.chatDetails)
    },
    setMembers(state, payload) {
      Vue.set(state.groupMembers, payload.id, payload.members)
    },
    addNotifications(state, payload) {
      Vue.set(state.notifications, payload.notifId, payload.notifDetails)
    }
  },
  actions: {
    fetchFeed ({commit}) {
      //const posts= []
      firebase.database().ref('posts/public/').once('value')
      .then ((data) => {
        const obj = data.val()
        for (let key in obj) {
          const posts = {
            id:key,
            title: obj[key].title,
            text: obj[key].text,
            date: obj[key].date,
            likes: obj[key].likes,
            public: obj[key].public,
            imageUrl: obj[key].imageUrl,
            authorId: obj[key].authorId,
            timeDelete: obj[key].timeDelete
            // private: false
          }
          commit('setFeeds', posts)
        }

      })
      .catch((error) => {
        console.log(error)
      })

    },
    fetchPrivateFeed({commit}) {
      //const posts = []
      firebase.database().ref('posts/private/' + this.state.user.id + '/').once('value')
      .then ((data) => {
        const obj = data.val()
        for (let key in obj) {
          //console.log(obj)
          const fileCipher = new encrFile()
          var mykey = crypto.createDecipher('aes-128-cbc', this.state.pKey.friendKey);
          var mykeyT = crypto.createDecipher('aes-128-cbc', this.state.pKey.friendKey);
          obj[key].title = mykey.update(obj[key].title, 'hex', 'utf8')
          obj[key].title += mykey.final('utf8');
          obj[key].text = mykeyT.update(obj[key].text,'hex', 'utf8')
          obj[key].text += mykeyT.final('utf8');
          if(obj[key].imageData != ''){
            fileCipher.decrypt(this.state.pKey.friendKey, obj[key].imageData)
            .then((result)=>{
              obj[key].imageUrl = result
                const posts = {
                  id:key,
                  title: obj[key].title,
                  text: obj[key].text,
                  date: obj[key].date,
                  likes: obj[key].likes,
                  public: obj[key].public,
                  imageUrl: obj[key].imageUrl,
                  authorId: obj[key].authorId,
                  timeDelete: obj[key].timeDelete
                  // private: true
                }
                commit('setPrivatePost', posts)
              })
              .then(()=>{
              })
            }else{
              const posts = {
                id:key,
                title: obj[key].title,
                text: obj[key].text,
                date: obj[key].date,
                likes: obj[key].likes,
                public: obj[key].public,
                imageUrl: obj[key].imageUrl,
                authorId: obj[key].authorId,
                timeDelete: obj[key].timeDelete
                // private: true
              }
              commit('setPrivatePost', posts)
            }
          }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    fetchPrivateFeedFromFriends({commit}, friendId) {
      //const posts = []
      const userid = this.state.user.id
      const privKey = this.state.pKey.privKey
      const puKey = this.state.pKey.publicKey
      const senderPublicKey = this.state.pKey.publicKey
      let reciverKey = 0;
      let friendKey = 0
      firebase.database().ref('keys/' + friendId + '/').once('value', snapshot => {
        const keys = snapshot.val()
        reciverKey = keys.publicKey
      })
      .then(function(){
      firebase.database().ref('friends/'+ userid  + '/' + friendId).once('value')
      .then((data) => {
        friendKey = data.val().friendKey
        let messagDecr = new messengerCr(puKey, privKey)
        friendKey = messagDecr.decrypt(reciverKey, friendKey)
      })
      .then(function(){
      firebase.database().ref('posts/private/' + friendId).once('value')
      .then ((data) => {
        const obj = data.val()
        for (let key in obj) {
          const fileCipher = new encrFile()
          var mykey = crypto.createDecipher('aes-128-cbc', friendKey);
          var mykeyT = crypto.createDecipher('aes-128-cbc', friendKey);
          obj[key].title = mykey.update(obj[key].title, 'hex', 'utf8')
          obj[key].title += mykey.final('utf8');
          obj[key].text = mykeyT.update(obj[key].text,'hex', 'utf8')
          obj[key].text += mykeyT.final('utf8');
          if(obj[key].imageData != ''){
            fileCipher.decrypt(friendKey, obj[key].imageData)
            .then((result)=>{
              obj[key].imageUrl = result
                const posts = {
                  id:key,
                  title: obj[key].title,
                  text: obj[key].text,
                  date: obj[key].date,
                  likes: obj[key].likes,
                  public: obj[key].public,
                  imageUrl: obj[key].imageUrl,
                  authorId: obj[key].authorId,
                  timeDelete: obj[key].timeDelete
                  // private: true
                }
                commit('setPrivatePost', posts)
              })
              .then(()=>{
              })
            }else{
              const posts = {
                id:key,
                title: obj[key].title,
                text: obj[key].text,
                date: obj[key].date,
                likes: obj[key].likes,
                public: obj[key].public,
                imageUrl: obj[key].imageUrl,
                authorId: obj[key].authorId,
                timeDelete: obj[key].timeDelete
                // private: true
              }
              commit('setPrivatePost', posts)
            }
          }
        //commit('setPrivatePost', posts)
      })
      .catch((error) => {
        console.log(error)
      })
      })
      })
    },
    createPost ({commit}, payload) {
      alert('You will be redirected when done uploading (please dismiss this box)')
      var post= {
        title: payload.title,
        imageUrl: payload.imageUrl,
        imageData: '',
        text: payload.text,
        date: payload.date,
        likes: 0,
        public: payload.public,
        authorId: this.state.user.id,
        timeDelete: payload.timeDelete
      }
      let key
      let user = this.state.user.id
      if(payload.public === true) {
        firebase.database().ref('posts/public/').push(post)
          .then((data) => {
            key= data.key
          })
          .then(() => {
            const filename = payload.imageFile.name
            const ext = filename.slice(filename.lastIndexOf('.'))
            //console.log(payload.picUrl)
            var task = firebase.storage().ref('posts/public/' + key + '.' + ext).put(payload.imageFile)
            task.on('state_changed', function(snapshot){
              //Notify user of completion state
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log('Upload:' + progress + '% complete');
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED:
                  console.log('Upload paused');
                  break;
                case firebase.storage.TaskState.RUNNING:
                  console.log('Upload running');
                  break;
              }
            }, function(error) {
              console.log(error)
            }, function() {
              task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                firebase.database().ref('posts/public/' + key).update({imageUrl: downloadURL})
              });
            });
          })
          .then(()=>{
            commit('createPost', {
              ...post,
              id: key
            })
          })
          .catch ((error) => {
            console.log(error)
          })
      }
      else {
        var mykey = crypto.createCipher('aes-128-cbc', this.state.pKey.friendKey);
        var mykeyT = crypto.createCipher('aes-128-cbc', this.state.pKey.friendKey);
        var newTitle = mykey.update(post.title, 'utf8', 'hex')
        newTitle += mykey.final('hex');
        var newText = mykeyT.update(post.text, 'utf8', 'hex')
        newText += mykeyT.final('hex');
        post.title = newTitle
        post.text = newText
        firebase.database().ref('posts/private/' + this.state.user.id +'/').push(post)
          .then((data) => {
            key= data.key
          })
          .then(() => {
              if(payload.imageData != ''){
                const fileCipher = new encrFile()
                const filename = payload.imageFile.name
                const ext = filename.slice(filename.lastIndexOf('.'))
                var task = firebase.storage().ref('posts/private/' + user +'/' + key + '.' + 'bin').put(fileCipher.encrypt(this.state.pKey.friendKey,payload.imageUrl))//payload.imageFile)
                task.on('state_changed', function(snapshot){
                  var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                  console.log('Upload:' + progress + '% complete');
                  switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED:
                      console.log('Upload paused');
                      break;
                    case firebase.storage.TaskState.RUNNING:
                      console.log('Upload running');
                      break;
                  }
                }, function(error) {
                  console.log(error)
                }, function() {
                  task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    firebase.database().ref('posts/private/' + user +'/' + key).update({
                      imageData: downloadURL,
                      imageUrl:''
                    })
                    router.push('/feed');
                    commit('likedPosts', {
                      ...post,
                      id: key
                    })
                  });
                });
              }
              else{
                router.push('/feed');
              }
          })
          .catch ((error) => {
            console.log(error)
          })
      }
    },
    registerUser({commit}, payload) {
      commit('setLoading', true)
      commit('clearError')

      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
      .then (
        response => {
          response.user.sendEmailVerification()
          commit('setLoading', false)
          const user = crypto.createECDH('secp256k1');
          user.generateKeys();
          const userPublicKey = user.getPublicKey().toString('base64');
          var userPrivKey = user.getPrivateKey().toString('base64');
          var friendPass = crypto.randomBytes(32).toString('base64');
          var storedPrivKey = null;
          var storedFriendKey = null;
          let userId = firebase.auth().currentUser.uid
          var hashpass = '';
          var salt = '';
          bcrypt.genSalt(12, function(err, salt) {
            bcrypt.hash(payload.password, salt, function(err, hash) {
              hashpass = hash.toString();
              salt = hashpass.slice(0, 29);
              hash = hashpass.slice(28, 60);
              const keyCipher = new cipher()
              storedPrivKey = keyCipher.encrypt(hash, userPrivKey)
              storedFriendKey = keyCipher.encrypt(hash,friendPass)
              firebase.database().ref('users/' + userId).set({
                email: payload.email,
                name: payload.name,
                online: true,
                username: payload.username,
                profilePic:'',
                id:userId,
                bio:'',
                privKey: storedPrivKey,
                friendPass: storedFriendKey,
                publicKey: userPublicKey,
                salt: salt
              });
              firebase.database().ref('keys/'+ userId).set({
                publicKey: userPublicKey,
              });
              alert("Please verify your email before logging in again.")
              /*
              commit('setUser', {
              id:userId,
              name: payload.name,
              email:payload.email,
              online:true,
              username:payload.username,
              profilePic:'',
              bio: '',
              })
              commit('setKey',{
              privKey: userPrivKey,
              friendKey: friendPass,
              publicKey: userPublicKey
              })
              */
            });
          })
          // this.$router.push("/")
        }
      )
      .catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
      )
    },
    signUserIn ({commit}, payload){
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(
        user=> {
          if(!user.user.emailVerified){
            alert('Please Verify your email')
            //console.log(user)
            user.user.sendEmailVerification()
            throw 'Please Verify email'
          }
          else{
            commit('setLoading', false)
            // this.$router.push("/")
            let userId = firebase.auth().currentUser.uid
            firebase.database().ref('/users/' + userId).once('value', snapshot => {
                      let userDetails = snapshot.val()
                      commit('setUser', {
                        name: userDetails.name,
                        email: userDetails.email,
                        id: userId,
                        username: userDetails.username,
                        profilePic: userDetails.profilePic,
                        bio: userDetails.bio
                      })
                      bcrypt.hash(payload.password, userDetails.salt, function(err, hash) {
                        const keyCipher = new cipher()
                        var hashpass = hash.toString();
                        hash = hashpass.slice(28, 60);
                        userDetails.privKey = keyCipher.decrypt(hash,userDetails.privKey)
                        userDetails.friendPass = keyCipher.decrypt(hash, userDetails.friendPass)
                        commit('setKey',{
                          privKey: userDetails.privKey,
                          friendKey: userDetails.friendPass,
                          publicKey: userDetails.publicKey,
                          dmKey: ''
                        })
                      });
            })
          }
        }
      )
      .catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
      )
    },
    signPassIn ({commit}, payload){
      commit('setLoading', true)
      commit('clearError')
      firebase.auth().signInWithEmailAndPassword(this.state.user.email, payload)
      .then(
        user=> {
          commit('setLoading', false)
          // this.$router.push("/")
          let userId = firebase.auth().currentUser.uid
          firebase.database().ref('/users/' + userId).once('value', snapshot => {
                    let userDetails = snapshot.val()
                    commit('setUser', {
                      name: userDetails.name,
                      email: userDetails.email,
                      id: userId,
                      username: userDetails.username,
                      profilePic: userDetails.profilePic,
                      bio: userDetails.bio
                    })
                    bcrypt.hash(payload.password, userDetails.salt, function(err, hash) {
                      const keyCipher = new cipher()
                      var hashpass = hash.toString();
                      hash = hashpass.slice(28, 60);
                      userDetails.privKey = keyCipher.decrypt(hash,userDetails.privKey)
                      userDetails.friendPass = keyCipher.decrypt(hash, userDetails.friendPass)
                      commit('setKey',{
                        privKey: userDetails.privKey,
                        friendKey: userDetails.friendPass,
                        publicKey: userDetails.publicKey
                      })
                    });
          })

        }
      )
      .catch(
        error => {
          commit('setLoading', false)
          commit('setError', error)
          console.log(error)
        }
      )
    },
    autoSignIn({commit}, payload){
      commit('setUser', {id:payload.id, online:true, email:payload.email, name:payload.name, username:payload.username, profilePic: payload.profilePic, bio:payload.bio})
      commit('setKey', {publicKey: payload.publicKey, privKey: payload.privKey, friendKey: payload.friendPass})
    },
    clearError({commit}){
      commit('clearError')
    },
    firebaseGetUsers({commit}){
      let users=[]
      firebase.database().ref('users/').on('child_added', snapshot => {
        let userDetails= snapshot.val()
        let userId= snapshot.key
        commit('addUser', {
          userId,
          userDetails
        })
      })

      firebase.database().ref('users/').once('value')
      .then((snapshot) => {
        let dmDetails = snapshot.val()
        for (let key in dmDetails) {
          users.push({
            id: key,
            name: dmDetails[key].name,
            profilePic: dmDetails[key].profilePic,
            username: dmDetails[key].username,
            bio:dmDetails[key].bio,

          })
        }
        commit('arrayUser', users)
      })
      .catch(error =>{
        console.log(error)
      })
    },
    signout({commit}){
      firebase.auth().signOut()
      commit('setUser', null)
      commit('disableKey')
      commit('signout')
      this.$router.push('/')
    },
    firebaseUpdateUser({commit}, payload) {
      if (payload.id) {
          this.state.user.name= payload.updates.name !== '' ? payload.updates.name : this.state.user.name
          this.state.user.profilePic= payload.updates.username !== '' ?  payload.updates.profilePic : this.state.user.profilePic
          this.state.user.bio= payload.updates.bio !== '' ? payload.updates.bio : this.state.user.bio
          this.state.user.username= payload.updates.username !== '' ? payload.updates.username : this.state.user.username
        console.log(commit)
        firebase.database().ref('users/' + payload.id).update(payload.updates)
        .then(() => {
          if(payload.imgName != ''){
            firebase.database().ref('users/' + payload.id).update({profilePic: ''})
            const filename = payload.imgName.name
            const ext = filename.slice(filename.lastIndexOf('.'))
            firebase.storage().ref('users/' + payload.id + '/').delete()
            var task = firebase.storage().ref('users/' + payload.id + '/picture' + ext).put(payload.imgName)
            task.on('state_changed', function(snapshot){
              //Notify user of completion state
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log('Upload:' + progress + '% complete');
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED:
                  console.log('Upload paused');
                  break;
                case firebase.storage.TaskState.RUNNING:
                  console.log('Upload running');
                  break;
              }
            },
            function(error) {
              alert(error)
            }, function() {
              task.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                firebase.database().ref('users/' + payload.id).update({profilePic: downloadURL})
              });
            });
          }
        })
      }
    },
    firebaseGetMessages({state}, payload) {
      let userId = state.user.id
      let reciverKey = null;
      let messDecr = new messengerCr(this.state.pKey.publicKey,this.state.pKey.privKey)
      firebase.database().ref('chats/' + userId + '/' + payload.friendId).limitToLast(payload.count).on('child_added', snapshot => {
        let messageDetails = snapshot.val()
        let messageId= snapshot.key
        messageDetails.text = messDecr.decrypt(this.state.pKey.dmKey, messageDetails.text)
        this.commit('addMessage', {
          messageId,
          messageDetails
        })
      })
    },
    getPukey({state},friendId){
      firebase.database().ref('keys/' + friendId + '/').once('value')
      .then(snapshot => {
        const keys = snapshot.val()
        this.commit('setKey',{
          privKey: state.pKey.privKey,
          friendKey: state.pKey.friendKey,
          publicKey: state.pKey.publicKey,
          dmKey: keys.publicKey
        })
      })
    },
    firebaseGetDMs({state}) {
      let userId = state.user.id
      let dms= []
      firebase.database().ref('chats/' + userId).once('value')
      .then((snapshot) => {
        let dmDetails = snapshot.val()
        for (let key in dmDetails) {
          dms.push({
          friendId: key
          })
        }
        this.commit('addDms', dms)
      })
      .catch(error =>{
        console.log(error)
      })
    },
    firebaseSendMessage({commit},payload) {
        let messEncr = new messengerCr(this.state.pKey.publicKey,this.state.pKey.privKey)
        payload.message.text = messEncr.encrypt(this.state.pKey.dmKey, payload.message.text)
        firebase.database().ref('chats/' + this.state.user.id + '/' + payload.otherUserId).push(payload.message)
        payload.message.from = 'them'
        firebase.database().ref('chats/' + payload.otherUserId + '/' + this.state.user.id).push(payload.message)
        firebase.database().ref('notifications/' + this.state.user.id + '/' + payload.otherUserId).update({
          lastSent: '' + new Date(),
          seen: true
        })
        firebase.database().ref('notifications/' + payload.otherUserId + '/' + this.state.user.id).update({
          lastSent: '' + new Date(),
          seen: false
        })
    },
    firebaseSeenNotification({state}, userId) {
      firebase.database().ref('notifications/' + state.user.id + '/' + userId).update({
        seen: true
      })
    },
    firebaseGetNotifications({commit, state}) {
      firebase.database().ref('notifications/' + state.user.id).on('child_added', snapshot => {
        let notifDetails = snapshot.val()
        let notifId = snapshot.key

        commit('addNotifications', {
          notifId,
          notifDetails: {
            ...notifDetails,
            notifId
          }
        })
      })
    },
    firebaseStopGettingMessages({commit}, otherUserId) {
      let userId = this.state.user.id
      if(firebase.database().ref('chats/' + userId + '/' + otherUserId)){
        firebase.database().ref('chats/' + userId + '/' + otherUserId).off('child_added')
        commit('clearMessages')
      }
    },
    firebaseGetPostInteraction ({commit}) {
      let userId= this.state.user.id
      firebase.database().ref('postinteraction/' + userId).on('child_added', snapshot => {
        let postDetails= snapshot.val()
        let postId= snapshot.key
        commit('addPostInteractions', {
          postId,
          postDetails
        })
      })
    },
    firebaseAddLikedPost({commit}, payload){
      let userId= this.state.user.id
      firebase.database().ref('postinteraction/' + userId + '/' + payload.id).set(payload.liked)
      .then((data) => {
        let details= payload.liked
        commit('likePosts', {
          id: payload.id,
          details
        })

        if(payload.public !== true){
          if(details) {
            firebase.database().ref('posts/private/' + payload.authorId + '/' + payload.id + '/').update({
              likes: payload.likes + 1
            })
          }
          else {
            firebase.database().ref('posts/private/' + payload.authorId + '/' + payload.id + '/').update({
              likes: payload.likes === 1 || payload.likes === 0 ? 0: payload.likes - 1
            })
          }
        }
        else {
          if(details) {
            firebase.database().ref('posts/public/' + payload.id + '/').update({
              likes: payload.likes + 1
            })
          }
          else {
            firebase.database().ref('posts/public/' + payload.id + '/').update({
              likes: payload.likes === 1 ? 0: payload.likes - 1
            })
          }
        }

      })
      .catch ((error) => {
        console.log(error)
      })

    },
    firebaseGetPostComments({commit}, postId) {
      firebase.database().ref('postcomments/' + postId).on('child_added', snapshot => {
        let commentDetails = snapshot.val()
        let commentId= snapshot.key
        commit('addComments', {
          commentId,
          commentDetails
        })
      })
    },
    firebaseStopGettingComments({commit}, postId) {
      if(firebase.database().ref('postcomments/' + postId)){
        firebase.database().ref('postcomments/' + postId).off('child_added')
        commit('clearComments')
      }
    },
    firebaseSendComment({commit}, payload) {
      firebase.database().ref('postcomments/' + payload.postId).push(payload.comment)
    },
    firebaseGetFriends({state}) {
      let userId = state.user.id
      firebase.database().ref('friends/' + userId).on('child_added', snapshot => {
        let friendDetails = snapshot.val()
        let friendId= snapshot.key
        this.commit('addFriends', {
          friendId,
          friendDetails: {
            ...friendDetails,
            friendId
          }
        })
      })
    },
    firebaseAddFriend({state}, friendId) {
      let userId= state.user.id
      let reciverKey = 0;
      const puKey = this.state.pKey.publicKey
      const prKey = this.state.pKey.privKey
      const frKey = this.state.pKey.friendKey

      firebase.database().ref('keys/' + friendId + '/').once('value' )
      .then((snapshot) => {
        const keys = snapshot.val()
        reciverKey = keys.publicKey
      })
      .then(function(){
        let messagEncr = new messengerCr(puKey, prKey)
        const newKey = messagEncr.encrypt(reciverKey, frKey)
        firebase.database().ref('friends/' + userId +'/' + friendId).update({
          me: true
        })
        firebase.database().ref('friends/' + friendId +'/' + userId).update({
          them: true,
          friendKey: newKey
        })
    })

    },
    firebaseGetPost({commit,state},postId){
      let feed= state.fetchFeed
      for(let fed in feed){
        if(feed[fed].id === postId) {
          commit('thisPost', feed[fed])
        }
      }
    },
    firebaseDisappearMessages({state}, friendId){
      for(let message in state.fetchMessages) {

        if(state.fetchMessages[message].timeDelete !== 'Forever'){
          if(state.fetchMessages[message].timeDelete <= '' +new Date()) {
            let m= message
            firebase.database().ref('chats/' + state.user.id + '/' + friendId + '/' + message).remove()
            firebase.database().ref('chats/' + friendId + '/' + state.user.id + '/' + m).remove()
        }
      }
      }
    },
    firebaseDeletePosts({state}) {
      for(let post in state.fetchFeed) {
        if(state.fetchFeed[post].public === false) {
          if(state.fetchFeed[post].timeDelete <= '' + new Date()) {
            firebase.database().ref('postinteraction/' + state.user.id + '/' + state.fetchFeed[post].id).remove()
            firebase.database().ref('postcomments/' + state.fetchFeed[post].id).remove()
            firebase.database().ref('posts/private/' + state.fetchFeed[post].authorId + '/' + state.fetchFeed[post].id).remove()
          }
        }
        else {
          if(state.fetchFeed[post].timeDelete <= '' + new Date()) {
            firebase.database().ref('postinteraction/' + state.user.id + '/' + state.fetchFeed[post].id).remove()
            firebase.database().ref('postcomments/' + state.fetchFeed[post].id).remove()
            firebase.database().ref('posts/public/' + state.fetchFeed[post].id).remove()
          }
        }
      }
    },
    createChat({state}, payload) {
      var groupPass = crypto.randomBytes(32).toString('base64');
      let passEncr = new messengerCr(this.state.pKey.publicKey, this.state.pKey.privKey)
      groupPass = passEncr.encrypt(this.state.pKey.publicKey, groupPass)
      firebase.database().ref('groupchat/' + state.user.id + '/').push({
        name: payload.name,
        imageUrl: payload.imageUrl,
        lastMessage: payload.lastMessage,
        owner: state.user.id,
        members: payload.members,
        key:groupPass,
        senderKey: this.state.pKey.publicKey
      })
      firebase.database().ref('groupchat/' + state.user.id + '/').on('child_added', snapshot => {
        this.firebaseUpdateChatMembers({
          chatId: snapshot.key,
          memberId: this.$store.state.user.id
        })
      })
    },
    firebaseGetGroupMembers({commit}, chatId ){
      firebase.database().ref('groupchatmembers/' + chatId).on('child_added', snapshot => {
        let members= snapshot.val()
        let id= snapshot.key
         commit('setMembers', {
           id,
           members: {
             ...members,
             id
           }
         })
      })
    },
    firebaseStopGettingGroupMembers({commit}, chatId){
      if(firebase.database().ref('groupchatmembers/' + chatId)){
        firebase.database().ref('groupchatmembers/' + chatId).off('child_added')
        commit('clearGroupMessages')
      }
    },
    firebaseUpdateChatMembers({state}, payload) {
      let passEncr = new messengerCr(this.state.pKey.publicKey, state.pKey.privKey)
      //payload.group.key = passEncr.decrypt(state.pKey.publicKey, payload.group.key)
      payload.group.senderKey = state.pKey.publicKey
      firebase.database().ref('keys/' + payload.memberId + '/').once('value', snapshot => {
        const keys = snapshot.val()
        payload.group.key = passEncr.encrypt(keys.publicKey, this.state.pKey.groupKey)
      })
      .then(()=>{
        firebase.database().ref('groupchatmembers/' + payload.chatId + '/' + payload.memberId).update(payload.member)
        //console.log(state)
        firebase.database().ref('groupchat/' + payload.memberId +'/' + payload.chatId).update(payload.group)
      })
    },
    firebaseGetGroupChat({commit, state}) {
      firebase.database().ref('groupchat/' + state.user.id).on('child_added', snapshot => {
        let chatDetails = snapshot.val()
        let chatId= snapshot.key
        commit('addGroupChat', {
          chatId,
          chatDetails: {
            ...chatDetails,
            chatId
          }
        })

        this.dispatch('firebaseGetGroupChatDm')
      })
    },
    firebaseGetGroupChatDm({commit, state}) {
      let dms= []
      firebase.database().ref('groupchat/' + state.user.id).once('value')
      .then((snapshot) => {
        let dmDetails = snapshot.val()
        for (let key in dmDetails) {
          dms.push({
            chatId: key,
            name: dmDetails[key].name,
            imageUrl: dmDetails[key].imageUrl
          })
        }
        commit('addDMGroups', dms)
      })
      .catch(error =>{
        console.log(error)
      })
    },
    firebaseGetGroupChatMessages({commit,state}, payload){

      firebase.database().ref('groupchat/' + this.state.user.id +'/' + payload.chatId).once('value', snapshot => {
        const messEncr = new messengerCr(this.state.pKey.publicKey,this.state.pKey.privKey)
        const key = messEncr.decrypt(snapshot.val().senderKey, snapshot.val().key)
        commit('setKey',{
          privKey: this.state.pKey.privKey,
          friendKey: this.state.pKey.friendPass,
          publicKey: this.state.pKey.publicKey,
          groupKey: key
        })
      })
      firebase.database().ref('groupchatmessages/' + payload.chatId).limitToLast(payload.count).on('child_added', snapshot => {
        let messageDetails = snapshot.val()
        var chatCipher = crypto.createDecipher('aes-128-cbc', this.state.pKey.groupKey);
        messageDetails.text = chatCipher.update(messageDetails.text, 'hex', 'utf8')
        messageDetails.text += chatCipher.final('utf8');
        let messageId= snapshot.key
        this.commit('addGroupMessage', {
          messageId,
          messageDetails
        })
      })
    },
    firebaseSendGroupMessage({commit}, payload) {
      var chatCipher = crypto.createCipher('aes-128-cbc', this.state.pKey.groupKey);
      payload.message.text = chatCipher.update(payload.message.text, 'utf8', 'hex')
      payload.message.text += chatCipher.final('hex');
      firebase.database().ref('groupchatmessages/' + payload.chatId).push(payload.message)
    },
    firebaseStopGettingGroupMessages({commit}, chatId) {
      // let userId = this.state.user.id
      if(firebase.database().ref('groupchatmessages/' + chatId)){
        firebase.database().ref('groupchatmessages/' + chatId).off('child_added')
        commit('clearMessages')
      }
    },
    firebaseDisappearGroupMessages({state}, chatId){
      for(let message in state.fetchMessages) {

        if(state.groupChat[message].timeDelete !== 'Forever'){
          if(state.groupChat[message].timeDelete <= '' +new Date()) {
            firebase.database().ref('groupchatmessages/' + chatId + '/' + message).remove()

        }
      }
      }
    }
  },
  modules: {
  }
})
